/**
 * REACT_APP_API_BASE, normalized. A value without a scheme (e.g.
 * "test.api.v1.indexx.ai") would be treated by axios as a relative path and
 * every call would hit the site's own 404, so default it to https://.
 * Empty when the variable is unset.
 */
const raw = (process.env.REACT_APP_API_BASE || '').trim().replace(/\/+$/, '');

export const API_BASE_OVERRIDE: string = !raw
  ? ''
  : /^https?:\/\//i.test(raw)
  ? raw
  : `https://${raw}`;
